import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = `${config.baseContainerUrl}/api/v1/`

export const getContainerTemplates = (params) => {
  return axios.request({
    url: `${baseUrl}container_template/`,
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const createContainerTemplate = (data, id) => {
  let url = `${baseUrl}container_template/`
  let method = 'post'
  if (id) {
    url += `${id}/`
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const detailContainerTemplate = (id) => {
  return axios.request({
    url: `${baseUrl}container_template/${id}/`,
    method: 'get'
  })
}

export const deleteContainerTemplate = (id) => {
  return axios.request({
    url: `${baseUrl}container_template/${id}/`,
    method: 'delete'
  })
}

// 模板类型
export const getContainerTemplateTypes = (params) => {
  return axios.request({
    url: `${baseUrl}container_template_type/`,
    params: params,
    method: 'get'
  })
}

export const editContainerTemplateType = (data, id) => {
  let url = `${baseUrl}container_template_type/`
  let method = 'post'
  if (id) {
    url += `${id}/`
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const detailContainerTemplateType = (id) => {
  return axios.request({
    url: `${baseUrl}container_template_type/${id}/`,
    method: 'get'
  })
}

export const deleteContainerTemplateType = (id) => {
  return axios.request({
    url: `${baseUrl}container_template_type/${id}/`,
    method: 'delete'
  })
}
